import { Box, Stack, Typography, IconButton, Tooltip } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { TEAM_COLOR_PRESETS } from '@/types';

interface Props {
  homeColor: string;
  awayColor: string;
  homeLabel?: string;
  awayLabel?: string;
  onChange: (side: 'home' | 'away', color: string) => void;
}

function ColorSwatch({
  color,
  selected,
  onClick,
}: {
  color: string;
  selected: boolean;
  onClick: () => void;
}) {
  return (
    <IconButton
      size="small"
      onClick={onClick}
      sx={{
        width: 32,
        height: 32,
        border: selected ? '2px solid' : '1px solid rgba(255,255,255,0.2)',
        borderColor: selected ? 'secondary.main' : 'rgba(255,255,255,0.2)',
        bgcolor: color,
        p: 0,
        '&:hover': { opacity: 0.85 },
      }}
    >
      {selected && (
        <CheckIcon sx={{ fontSize: 16, color: color === '#ffffff' || color === '#ffeb3b' ? '#000' : '#fff' }} />
      )}
    </IconButton>
  );
}

export default function TeamColorPicker({ homeColor, awayColor, homeLabel = '主隊', awayLabel = '客隊', onChange }: Props) {
  return (
    <Stack spacing={2}>
      {(['home', 'away'] as const).map((side) => {
        const color = side === 'home' ? homeColor : awayColor;
        const label = side === 'home' ? homeLabel : awayLabel;
        return (
          <Box key={side}>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
              <Box sx={{ width: 14, height: 14, borderRadius: '50%', bgcolor: color, border: '1px solid rgba(255,255,255,0.3)' }} />
              <Typography variant="body2" fontWeight={600}>
                {label}顏色
              </Typography>
            </Stack>
            <Stack direction="row" flexWrap="wrap" gap={0.5}>
              {TEAM_COLOR_PRESETS.map((preset) => (
                <Tooltip key={`${side}-${preset}`} title={preset}>
                  <span>
                    <ColorSwatch
                      color={preset}
                      selected={color === preset}
                      onClick={() => onChange(side, preset)}
                    />
                  </span>
                </Tooltip>
              ))}
            </Stack>
          </Box>
        );
      })}
    </Stack>
  );
}
